module.exports = __webpack_public_path__ + "static/img/6.1f73b83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/6.png
// module id = z3EM
// module chunks = 0